import _ from "lodash";
import React from "react";
import styled from "styled-components";

import {
  // RichContentDisplayOptions,
  Text,
  VSpace,
  Badge,
} from "@examspark/common-ui/server";
import { ParsedUnitObjective } from "@examspark/types";

import PrintUnitContent from "./PrintUnitContent";

type Props = {
  objective: ParsedUnitObjective | null | undefined;
  showAnnotationNotes?: boolean;
  showAnnotationCcrs?: boolean;
  showAnnotationRcfp?: boolean;
};

const StyledSpecificity = styled(Text.Body)`
  .examspark-mark-tecd {
  }
`;

const StyledAnnotation = styled.div`
  padding: 1.5rem;
  border-radius: 0.25rem;
  font-size: 1.3rem;

  ${Badge} {
    color: white;
    margin-bottom: 0.5rem;
    text-align: center;
    border: none;
  }
`;

const StyledSpecificityContent = styled(StyledAnnotation)`
  border: solid 1px #ddd;

  & > div {
    color: #3b3beb;
  }

  ${Badge} {
    background-color: #666;
    margin-bottom: 2rem;
  }
`;

const StyledNotesAnnotation = styled(StyledAnnotation)`
  background-color: #f4f4f4;
  & > div {
    color: #3b3beb;
  }
  ${Badge} {
    background-color: #666;
  }
`;

const StyledCcrsRcfpAnnotation = styled(StyledAnnotation)`
  background-color: #f4f4f4;
  ${Badge} {
    background-color: #666;
  }
`;

const ObjectiveSpecificity = ({
  objective,
  showAnnotationNotes,
  showAnnotationCcrs,
  showAnnotationRcfp,
}: Props) => {
  if (objective == null) return null;

  const customizations = objective.objectivesItem?.data;

  const annotations = _.keyBy(
    objective.annotations?.filter((a) => !!a.content?.length) ?? [],
    (a) => a.label ?? "",
  );

  // const hasCustomSpecificity =
  //   customizations?.notes != null && customizations?.notes !== objective.notes;

  if (!(customizations?.notes ?? objective.notes)) {
    return null;
  }

  // @TODO: Do we ever show custom specificity?
  const specificityToDisplay = objective.notes;

  // const renderOptions: RichContentDisplayOptions = {
  //   marks: {
  //     tecd: showEnhancedClarification ? "include" : "exclude",
  //   },
  // };

  return (
    <VSpace size="1rem">
      {(customizations?.notes != null || objective.notes != null) && (
        <StyledSpecificity>
          <StyledSpecificityContent>
            <Badge>TEKS RS Specificity</Badge>
            <PrintUnitContent content={specificityToDisplay} />
          </StyledSpecificityContent>
        </StyledSpecificity>
      )}
      {!!showAnnotationNotes && "tcmpc.notes" in annotations && (
        <StyledNotesAnnotation>
          <Badge>TEKS RS Notes</Badge>
          <PrintUnitContent
            content={annotations["tcmpc.notes"]?.content ?? ""}
          />
        </StyledNotesAnnotation>
      )}
      {!!showAnnotationRcfp && "tcmpc.rcfp" in annotations && (
        <StyledCcrsRcfpAnnotation>
          <Badge>TxRCFP</Badge>
          <PrintUnitContent
            content={annotations["tcmpc.rcfp"]?.content ?? ""}
          />
        </StyledCcrsRcfpAnnotation>
      )}
      {!!showAnnotationCcrs && "tcmpc.ccrs" in annotations && (
        <StyledCcrsRcfpAnnotation>
          <Badge>TxCCRS</Badge>
          <PrintUnitContent
            content={annotations["tcmpc.ccrs"]?.content ?? ""}
          />
        </StyledCcrsRcfpAnnotation>
      )}
    </VSpace>
  );
};

export default ObjectiveSpecificity;
